<template>
  <div
    id="correct-answer-container"
    class="knowledge-test-correct-answer-container"
  >
    <div class="knowledge-test-correct-answer-container--item">
      <Header/>
    </div>
    <div class="section-gray">
      <div
        class="knowledge-test-correct-answer-container--content"
      >
        <div class="knowledge-test-title">
          {{ $t('menu.knowledge_test_correct_answer') }}
        </div>
        <div class="section-white">
          <div v-if="Object.keys(userSelectWrongAnswer).length">
            <p
              class="risk-point"
              v-html="$t('summart_of_knowledge_test.user_risk_point', { knowledgeTestPoint: userKnowledgeTest.knowledgeTestPoint })"
            />
            <div
              v-for="(choiceQuestion, index) in userSelectWrongAnswer"
              :key="index"
              :id="`question-${(index + 1)}`"
            >
              <div class="question">
                {{ (index + 1) }}. {{ $t(`${choiceQuestion.Q.toLowerCase()}`) }}
              </div>
              <span class="is-invalid">{{ errors.first(`question ${(index + 1)}`) }}</span>
              <div class="answers">
                <div
                  v-for="(point, choice) in getAllAnswerPoint(choiceQuestion.Q)"
                  :key="choice"
                  :class="['answer', {'choice-correct': point === 1 }]"
                >
                  <b-radio
                    v-model="choiceQuestion.A[0].text"
                    :native-value="`${choiceQuestion.Q.replace(/.Q$/g, '')}.${choice.toUpperCase()}`"
                    :name="`question ${choiceQuestion.Q.replace(/.Q$/g, '')}.${choice.toUpperCase()}`"
                    disabled
                  >
                    {{ $t(`${choiceQuestion.Q.toLowerCase().split('.')[0].toLowerCase()}.${choiceQuestion.Q.toLowerCase().split('.')[1]}.${choiceQuestion.Q.toLowerCase().split('.')[2]}.${choice}`) }}
                  </b-radio>
                </div>
                <div class="correct-answer-wrap">
                  <p class="correct-answer-wrap--title"> {{ $t('knowledge_test_correct_answer.correct_answer') }}</p>
                  <span class="correct-answer-wrap--ans">
                    {{ $t(`${choiceQuestion.Q.replace(/.Q$/g, '').toLowerCase()}.${findAnswerCorrectFromQuestion(choiceQuestion.A[0].text)}`) }}
                  </span>
                </div>
              </div>
            </div>
            <b-button
              class="submit-btn"
              data-test="knowledge-test-correct-answer--submit-btn"
              @click="$router.push({ name: 'KnowledgeTest' })"
            >
              Next
            </b-button>
          </div>
          <div v-else>
            <div
              v-for="(index) in 10"
              :key="index"
              class="skeleton-container"
            >
              <b-skeleton
                height="20px"
                width="70%"
              />
              <b-skeleton
                height="20px"
                width="55%"
              />
              <b-skeleton
                height="20px"
                width="30%"
              />
              <b-skeleton
                height="20px"
                width="40%"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="knowledge-test-correct-answer-container--item">
      <Footer/>
    </div>
  </div>
</template>

<script>
import Header from '@/features/Header'
import Footer from '@/components/Footer'
import SummaryOfKnowledgeTest from '@/components/SummaryOfKnowledgeTest'
import KnowledgeTestAnswers from '@/assets/json/knowledgeTestAnswers'
import KnowledgeTestAnswersV2 from '@/assets/json/knowledgeTestAnswersV2'

import { mapState } from 'vuex'
import cookie from '@/utils/cookie'
import Service from './service.js'
import { kulapApi } from '@/resources'

export default {
  name: 'KnowledgeTestCorrectAnswer',
  components: {
    Header,
    Footer,
    SummaryOfKnowledgeTest
  },
  data () {
    return {
      service: null,
      knowledgeTestAns: KnowledgeTestAnswers,
      knowledgeTestAnsV2: KnowledgeTestAnswersV2,
      userKnowledgeTest: {},
      correctAnswer: {},
      userSelectWrongAnswer: []
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  async created () {
    if (!cookie.get('user') || !cookie.get('accessToken')) {
      this.$router.push({ name: 'Login', query: { next: 'KnowledgeTestCorrectAnswer' } })
      return
    }
    this.service = new Service({
      store: this.$store,
      kulapApi
    })
    const user = await this.service.getUserProfile()
    if (!user.isActive) {
      this.$router.push({ name: 'Exchange' })
    }
    const userKnowledgeTest = await this.service.getUserKnowledgeTest()
    this.userKnowledgeTest = userKnowledgeTest
    this.filterCorrectAnswer()
    this.$scrollTo('#correct-answer-container')
  },
  methods: {
    filterCorrectAnswer () {
      const result = this.userKnowledgeTest.data.filter(ans => {
        return ans['A'][0].point === 0
      })
      if (result.length === 0) {
        this.$router.push({ name: 'KnowledgeTest' })
        return
      }
      this.userSelectWrongAnswer = result
    },

    findAnswerCorrectFromQuestion (questionText) {
      // TODO: fast code
      const KnowledgeTestAnswersForCheck = questionText.toLowerCase().split('.')[0] === 'knowledge_test' ? KnowledgeTestAnswers : KnowledgeTestAnswersV2
      const group = questionText.toLowerCase().split('.')[1]
      const qid = questionText.toLowerCase().split('.')[2]
      for (const correctAns in KnowledgeTestAnswersForCheck[group][qid]) {
        if (KnowledgeTestAnswersForCheck[group][qid][correctAns] === 1) {
          return correctAns
        }
      }
    },

    getAllAnswerPoint (questionText) {
      // TODO: fast code
      const KnowledgeTestAnswersForCheck = questionText.toLowerCase().split('.')[0] === 'knowledge_test' ? KnowledgeTestAnswers : KnowledgeTestAnswersV2
      return KnowledgeTestAnswersForCheck[questionText.toLowerCase().split('.')[1]][questionText.toLowerCase().split('.')[2]]
    }
  }
}
</script>

<style lang="scss">
  #correct-answer-container {
    .choice-correct {
      .b-radio {
        &.radio {
          input[type=radio] {
            +.check {
              border: #0559af 2px solid !important;
            }
          }
        }
      }
    }
  }
</style>

<style lang="scss" scoped>
.knowledge-test-correct-answer-container {
  float: left;
  width: 100%;
  min-height: 100vh;
  &--item {
    float: left;
    width: 100%;
  }
  &--content {
    max-width: 1024px;
    margin: 0 auto;
  }
}
.section-gray {
  float: left;
  width: 100%;
  padding-bottom: 80px;
}
.knowledge-test-title {
  margin: 35px 0;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  color: #000000;
}
.section-white {
  display: block;
  margin: 0 auto;
  padding: 50px;
  max-width: 1024px;
  width: calc(100% - 20px);
  border-radius: 3px;
  box-shadow: 0 0 6px -2px rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
}
.question {
  font-family: Roboto;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.3px;
  color: #000000;
}
.answers {
  margin-top: 20px;
  margin-left: 5px;
  margin-bottom: 30px;
  .answer {
    font-family: Roboto;
    font-size: 14px;
    color: #000000;
    padding: 10px 0 10px 10px;
  }

  .choice-correct {
    // background-color: #0559af;
    .radio[disabled] {
      font-weight: 600 !important;
      color: #0559af !important;
      opacity: 1 !important;
    }
  }
}

.skeleton-container {
  margin-bottom: 40px;
}

.correct-answer-wrap {
  padding: 10px 20px;
  background-color: #f1f1f1;
  margin-top: 20px;

  &--title {
    font-size: 18px;
    font-weight: 700;
    line-height: 35px;
    color: #0559af;
  }

  &--ans {
    font-weight: 500;
  }
}

.risk-point {
  font-size: 20px;
  text-align: center;
  margin: 40px 0 36px 0;
}

.submit-btn {
  display: flex;
  justify-content: center;
  width: 165px;
  height: 45px;
  border-radius: 3px;
  border: unset;
  box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.5);
  background-color: #2193ff;
  margin: 50px auto 0;
  font-family: Roboto;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.37px;
  text-align: center;
  color: #ffffff;
  padding: 13px 0px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/KnowledgeTestCorrectAnswer/index.vue